<template lang="pug">
v-carousel.mt-10.page-home-shops(
  v-if="shops.length",
  height="max-content",
  hide-delimiters,
  :show-arrows="shops.length !== 1"
)
  v-carousel-item(
    v-for="({ title, local, link, map, tel, whatsapp, img, text }, i) in shops",
    :key="i"
  )
    grid-container.mx-auto.justify-center(
      cols="auto",
      cols-md="auto max-content",
      gap="0",
      gap-md="40px",
      style="max-width: 1000px"
    )
      .px-3
        .text-h6.text-uppercase.accent--text.font-weight-bold.text-center.mb-4
          .pt-sans {{ title }}
        .d-flex.flex-column.mb-5
          a.text-decoration-none.grey--text.text--darken-3(
            :href="link",
            target="_blank"
          )
            v-icon(color="primary", left) fas fa-map-marker-alt
            span {{ local }}
          a.text-decoration-none.grey--text.text--darken-3.mt-2(
            v-if="tel",
            :href="getTelLinkFromPhone(tel)",
            target="_self"
          )
            v-icon(color="primary", left) fas fa-phone
            span {{ tel }}
          a.text-decoration-none.grey--text.text--darken-3.mt-2(
            v-if="whatsapp"
            :href="getWhatsappLinkFromPhone(whatsapp)",
            target="_blank"
          )
            v-icon(color="primary", left) fab fa-whatsapp
            span {{ whatsapp }}
        .black--text(v-html="text")
      v-img.rounded(
        :src="img",
        :width="sm ? '100%' : '540px'",
        :height="sm ? 'auto' : '320px'"
      )
    iframe.page-home-shops-local.rounded-sm.elevation-1.mx-auto.secondary.mt-md-8(
      :src="map",
      frameborder="0",
      allowfullscreen,
      aria-hidden="false",
      tabindex="0"
    )
</template>

<script>
import PageTemplate from "@/components/templates/Page.vue";
import { getTelLinkFromPhone, getWhatsappLinkFromPhone } from "@/components/utils/";

export default {
  computed: {
    shops() {
      return this.$rest("shops").list.map(
        ({ title, local, link, map, tel, whatsapp, img, text }) => ({
          img: img ? this.files + img : "",
          title,
          local,
          link,
          map,
          tel,
          whatsapp,
          text,
        })
      );
    },
    // shops() {
    //   const shops = this.$rest("shops").list.map(
    //     ({ title, local, tel, img, text }) => ({
    //       img: img ? this.files + img : "",
    //       title,
    //       local,
    //       tel,
    //       text,
    //     })
    //   );
    //   if (!shops[0]) return [];
    //   return [shops[0], shops[0], shops[0]];
    // },
    sm() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  methods: {
    getTelLinkFromPhone,
    getWhatsappLinkFromPhone,
  },
  beforeCreate() {
    this.$rest("shops").get();
  },
  components: {
    PageTemplate,
  },
};
</script>

<style>
.page-home-shops-local {
  width: 100vw;
  height: 500px;
  margin-bottom: -6px;
}

@media screen and (min-width: 960.001px) {
  .page-home-shops .v-window__prev,
  .page-home-shops .v-window__next {
    top: 140px !important;
  }
}
@media screen and (max-width: 960px) {
  .page-home-shops-local {
    height: 50vw;
  }
}
@media screen and (max-width: 600px) {
  .page-home-shops-local {
    height: 100vw;
  }
}
</style>
